import { Module01, Module01Props } from 'components/gruenland/organisms/mod01HeroBanner/Module01';
import { TasticProps } from '../../types';

const HeroBannerTastic = ({ data }: TasticProps<Module01Props>) => {
  return <Module01 slides={data.slides} />;
};
export default HeroBannerTastic;
